module.exports = __webpack_public_path__ + "img/China-5-hover.da1b099d.jpg";